



















































































































































































import { ProfileState, RootState, Profile } from "../types";
import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GET_PROFILE_DATA, LOGOUT } from "../store/actions.names";
import { HOST, API_URL } from "../global";
import { SET_PROFILE_DATA, SET_PROFILE_ERROR } from "../store/mutations.names";
import {
  USER_USERNAME,
  USER_FULL_NAME,
  USER_IDENTITY,
  AUTH_TOKEN
} from "../store/getters.names";
import axios from "axios";
import moment from "moment";
import imagesLoaded from "imagesloaded";
// import Masonry from 'masonry-layout';

@Component({
  name: "Dashboard"
})
export default class Dashboard extends Vue {
  @Action(GET_PROFILE_DATA) getProfileData : any; 
  @Mutation(SET_PROFILE_DATA) public setProfileData : any;
  @Action(LOGOUT) public logout : any;
  @Getter(AUTH_TOKEN) public authToken : any;

  // @Getter(IS_LOGGED_IN) isLoggedIn!: boolean;
  // //@Mutation(TOGGLE_LOGIN) [TOGGLE_LOGIN] : any;
  // @Action(LOGIN) login : any;



  public isDropped: boolean = false;
  public isSidebarShow: boolean = false;
  public customerProfile: any = [];
  public userData: any = [];
  public user: any | null = null;
  public username: any | null = null;
  public HOST: string = HOST;
  public isActive: boolean = true;
  public isnavActive: boolean = true;
  public currentCategory: string = "all";
    public categories: any = {
        all: "All Updates",
        construction: "Construction",
        financial: "Financial"
    }
  public userProfile() {
    this.isDropped = !this.isDropped;
  }
  public openSideMenu() {
    this.isSidebarShow = !this.isSidebarShow;
  }
 public activenav() {
    this.isnavActive = !this.isnavActive;
  }
  get filteredUpdates(){
      if (this.currentCategory === "all"){
          return this.userData;
      } else {
          return this.userData.filter((item: any) => {
              return item.update.type == this.currentCategory
          });
      }
  }

  get moment() {
    return moment;
  }
	// triggerMasonry() {
	// 		console.log('triggerMasonry');
	// 		var grid = document.querySelector('.grid');
	// 		var msnry = new Masonry( grid, {
	// 			itemSelector: '.grid-item',
	// 			columnWidth: 350
	// 		});
    //     }
        
  public logoutUser() {
    (this as any)[LOGOUT]().then(() => {
      this.$router.push("login");
    });
  }

  getprofileData(): any {
    axios
      .get(`${API_URL}/others/customer-profile/`, {
        headers: {
          Authorization: `Token ${(this as any)[AUTH_TOKEN]}`
        }
      })
      .then(({ data }) => {
        this.customerProfile = data;
      });
  }

  getuserProjectData(): any {
    axios
      .get(`${API_URL}/updates/`, {
        headers: {
          Authorization: `Token ${(this as any)[AUTH_TOKEN]}`
        }
      })
      .then(({ data }) => {
        this.userData = data;
      });
  }


openmenu () {

 (this.$refs.sideBar as HTMLElement).classList.toggle("sb-menu");
}

  public mounted() {
    this.getprofileData();
    this.getuserProjectData();
    // this.triggerMasonry();
   // this.masonry();
    //(this as any).openmenu();
    //this.dropdown();
    //console.log(this.getprofileData());

  // console.log(this.customerProfile);
  }
  /*
public dropdown()
 {
    //toggle dropdown menu open/close
   
   var toClose = false;

    function toggle(e: any) {
        e.stopPropagation();
         let btn : any = this;
        var menu = btn.nextSibling;

        while (menu && menu.nodeType != 1) {
            menu = menu.nextSibling
        }
        if (!menu) return;
        if (menu.style.display !== 'block') {
            menu.style.display = 'block';
            if (toClose) toClose.style.display = "none";
            toClose = menu;
        } else {
            menu.style.display = 'none';
            toClose = false;
        }

    };

    function closeAll() {
        toClose.style.display = 'none';
    };

    window.addEventListener("DOMContentLoaded", function() {
        document.querySelectorAll(".allup, .pro-link, .ntf-btn").forEach(function(btn) {
            btn.addEventListener("click", toggle, true);
        });
    });

   // let floorElements = document.getElementsByClassName("floor") as HTMLCollectionOf<HTMLElement>;


    // End toggle button

    // start search button 
    // function opensearch(e: any) {
    //      e.preventDefault();
    //     let d : any = document;
    //     var element = d.getElementById("search-btn");
    //     element.classList.toggle("shexpand");
    // }
    // End search button

    // sidebar minimize js 
    // function openmenu(e: any) {
    //     e.preventDefault();
    //     let d : any = document;
    //     var elem = d.getElementById("sidebar");
    //     elem.classList.toggle("sb-menu");
    // }
    
 }
 */
}
